export default {
	meta: {
		title: 'IDEL Convention',
		description: 'Gérer les destinataires de versement IDELs'
	}
};
